import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import {
  Users,
  GraduationCap,
  FileText,
  Award,
  TrendingUp,
  Shield,
  Database
} from "lucide-react";
import { useEffect, useState } from "react";
import { awardsApi, BachelorDegreeFilters, bachelorDegreesApi, LanguageCertificateFilters, languageCertificatesApi, MasterDegreeFilters, masterDegreesApi } from "@/lib";


function BachelorCard() {
  const [totalBachelors, setTotalBachelors] = useState(0)

  useEffect(() => {
    (async () => {
      const bachelorDegrees = await bachelorDegreesApi.count() as unknown as number;
      setTotalBachelors(bachelorDegrees)
    })();
  }, [])

  return <Card>
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-muted-foreground">Bằng Tốt nghiệp</p>
          <p className="text-2xl">{totalBachelors.toLocaleString('vi-VN')}</p>
        </div>
        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
          <GraduationCap className="w-6 h-6 text-purple-600" />
        </div>
      </div>
      {/* <div className="mt-2 flex items-center text-sm">
            <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
            <span className="text-green-500">+12.1%</span>
            <span className="text-muted-foreground ml-1">từ tháng trước</span>
          </div> */}
    </CardContent>
  </Card>
}
function MasterCard() {
  const [totalMasters, setTotalMasters] = useState(0)

  useEffect(() => {
    (async () => {
      const masterDegrees = await masterDegreesApi.count() as unknown as number;
      setTotalMasters(masterDegrees)
    })();
  }, [])

  return <Card>
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-muted-foreground">Bằng Thạc sĩ</p>
          <p className="text-2xl">{totalMasters.toLocaleString('vi-VN')}</p>
        </div>
        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
          <GraduationCap className="w-6 h-6 text-purple-600" />
        </div>
      </div>
      {/* <div className="mt-2 flex items-center text-sm">
            <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
            <span className="text-green-500">+12.1%</span>
            <span className="text-muted-foreground ml-1">từ tháng trước</span>
          </div> */}
    </CardContent>
  </Card>
}

function LanguageCard() {
  const [totalCertificates, setTotalMaster] = useState(0)
  useEffect(() => {
    (async () => {
      const languageCertificates = await languageCertificatesApi.count() as unknown as number;
      setTotalMaster(languageCertificates)
    })();
  }, [])
  return <Card>
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-muted-foreground">Chứng chỉ ngoại ngữ</p>
          <p className="text-2xl">{totalCertificates.toLocaleString('vi-VN')}</p>
        </div>
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
          <FileText className="w-6 h-6 text-green-600" />
        </div>
      </div>
      {/* <div className="mt-2 flex items-center text-sm">
              <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
              <span className="text-green-500">+8.7%</span>
              <span className="text-muted-foreground ml-1">từ tháng trước</span>
            </div> */}
    </CardContent>
  </Card>
}

function AwardCard() {

  const [totalAwards, setTotalAwards] = useState(0)

  useEffect(() => {
    (async () => {
      const awards = await awardsApi.count() as unknown as number;
      setTotalAwards(awards)
    })();
  }, [])

  return <Card>
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-muted-foreground">Khen thưởng - Chứng nhận</p>
          <p className="text-2xl">{totalAwards.toLocaleString('vi-VN')}</p>
        </div>
        <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
          <Award className="w-6 h-6 text-yellow-600" />
        </div>
      </div>
      {/* <div className="mt-2 flex items-center text-sm">
              <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
              <span className="text-green-500">+3.4%</span>
              <span className="text-muted-foreground ml-1">từ tháng trước</span>
            </div> */}
    </CardContent>
  </Card>
}

export default function AdminDashboardOverview() {

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl mb-2">Tổng quan hệ thống</h2>
        <p className="text-muted-foreground">
          Thống kê và quản lý toàn bộ văn bằng, chứng chỉ, khen thưởng - chứng nhận
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">Tổng số User</p>
                <p className="text-2xl">{stats.totalUsers.toLocaleString('vi-VN')}</p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <Users className="w-6 h-6 text-blue-600" />
              </div>
            </div>
            <div className="mt-2 flex items-center text-sm">
              <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
              <span className="text-green-500">+5.2%</span>
              <span className="text-muted-foreground ml-1">từ tháng trước</span>
            </div>
          </CardContent>
        </Card> */}

        <BachelorCard />
        <MasterCard />

        <LanguageCard />
        <AwardCard />



        {/* <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">Tài liệu hợp lệ</p>
                <p className="text-2xl">{stats.validDocuments.toLocaleString('vi-VN')}</p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <Shield className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="mt-2">
              <Badge variant="secondary" className="text-xs bg-green-100 text-green-700">
                Tỷ lệ: 98.2%
              </Badge>
            </div>
          </CardContent>
        </Card> */}

        {/* <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">Tài liệu bị thu hồi</p>
                <p className="text-2xl text-red-600">{stats.revokedDocuments.toLocaleString('vi-VN')}</p>
              </div>
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <Database className="w-6 h-6 text-red-600" />
              </div>
            </div>
            <div className="mt-2">
              <Badge variant="destructive" className="text-xs">
                Cần xem xét
              </Badge>
            </div>
          </CardContent>
        </Card> */}
      </div>

      {/* <Card>
        <CardHeader>
          <CardTitle>Hoạt động gần đây</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center gap-4 p-3 bg-muted/50 rounded-lg">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm">Thêm mới 15 văn bằng cho khoa Công nghệ Thông tin</p>
                <p className="text-xs text-muted-foreground">2 giờ trước</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-3 bg-muted/50 rounded-lg">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm">Cập nhật thông tin 8 chứng chỉ tiếng Anh</p>
                <p className="text-xs text-muted-foreground">4 giờ trước</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-3 bg-muted/50 rounded-lg">
              <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm">Thu hồi 2 văn bằng do vi phạm quy định</p>
                <p className="text-xs text-muted-foreground">1 ngày trước</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card> */}
    </div>
  );
}